import { motion } from 'framer-motion';

const ease = [0.22, 1, 0.36, 1] as const;

type Feature = {
  title: string;
  subtitle: string;
};

const FEATURES: Feature[] = [
  {
    title: 'Mock interview',
    subtitle:
      'Twenty questions, asked one at a time, same order and pace as the actual interview. Say your answer, get scored instantly against the same accepted variants USCIS uses.',
  },
  {
    title: 'Practice mode',
    subtitle:
      'All 128 civics questions, the ten N-400 personal questions, and reading and writing. Searchable, with explanations.',
  },
  {
    title: 'Weak-area review',
    subtitle:
      'After each session you see the categories you missed. Drill those, retake, watch the score move.',
  },
];

export default function FeatureShowcase() {
  return (
    <section id="features" className="relative bg-cream py-28 md:py-36">
      <div className="mx-auto w-full max-w-5xl px-6 md:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-15%' }}
          transition={{ duration: 0.7, ease }}
          className="grid grid-cols-12 gap-8 md:gap-12"
        >
          <div className="col-span-12 md:col-span-5">
            <div className="md:sticky md:top-24">
              <p className="font-display font-light text-sm text-text-secondary mb-5 flex items-center gap-3">
                <span className="tabular-nums">02</span>
                <span className="w-8 h-px bg-text-muted/50" />
                <span>What's inside</span>
              </p>
              <h2 className="font-display font-light text-4xl md:text-5xl leading-[1.1] tracking-[-0.01em] text-text-primary mb-5 max-w-[14ch]">
                Three ways to practice. One exam.
              </h2>
              <p className="font-sans text-base text-text-secondary max-w-[36ch] leading-relaxed">
                Each is a real screen in the app. Not a marketing illustration.
              </p>
            </div>
          </div>

          <ol className="col-span-12 md:col-span-7 divide-y divide-border">
            {FEATURES.map((f, i) => (
              <li
                key={f.title}
                className="py-8 first:pt-0 last:pb-0 grid grid-cols-[2.5rem_1fr] gap-5 items-baseline"
              >
                <span className="font-display font-light text-2xl text-primary tabular-nums leading-none">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <div>
                  <h3 className="font-display font-semibold text-2xl md:text-[28px] text-text-primary leading-snug mb-2 tracking-[-0.005em]">
                    {f.title}
                  </h3>
                  <p className="font-sans text-base text-text-secondary leading-relaxed max-w-[44ch]">
                    {f.subtitle}
                  </p>
                </div>
              </li>
            ))}
          </ol>
        </motion.div>
      </div>
    </section>
  );
}
